import React, { Component } from 'react';
import PropTypes from 'prop-types';

class LockIcon extends Component {
  constructor(props) {
    super(props);

    this.attachBindings();
  }

  attachBindings() {
    this.onMouseOver = this.props.onMouseOver.bind(this);
  }

  render() {
    return (
      <svg onMouseOver={this.onMouseOver} onFocus={() => { }} className="lock-icon" color={'#595959'} width="9px" height="12px" viewBox="0 0 9 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <title>Lock Icon</title>
        <g id="Report-Builder" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Reports-v2-(iteration)-variant-2---Report-Filters-Open---Date-Range" transform="translate(-306.000000, -911.000000)">
            <g id="Builder" transform="translate(255.000000, 244.000000)">
              <g id="Section-3-(open)" transform="translate(0.000000, 130.000000)">
                <g id="Date-Selector" transform="translate(25.000000, 69.000000)">
                  <g id="Filter---Locked" transform="translate(14.000000, 458.000000)">
                    <g id="icon-/-lock" transform="translate(12.000000, 10.000000)">
                      <g id="Lock-Icon">
                        <path d="M1.5,4.5 L7.5,4.5 L7.5,3.5 C7.5,1.84314575 6.15685425,0.5 4.5,0.5 C2.84314575,0.5 1.5,1.84314575 1.5,3.5 L1.5,4.5 Z" id="Rectangle-14" stroke="currentColor" />
                        <rect id="Rectangle-15" stroke="currentColor" x="0.5" y="4.5" width="8" height="7" />
                        <rect id="Rectangle-16" fill="currentColor" x="4" y="6" width="1" height="4" />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

LockIcon.propTypes = {
  onMouseOver: PropTypes.func,
  fill: PropTypes.string,
};

LockIcon.defaultProps = {
  onMouseOver: () => { },
  fill: '#595959',
};

export default LockIcon;
